import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Employment/Vacancies</h1>
                <p>Home &gt; Employment/Vacancies</p>
            </div>
        </div>
    );
};

export default Hero;
